export class NotesValidator {
    public static NOTES_VALIDATION_MESSAGES = {
        'note': [
            { type: 'required', message: 'Nota es requerido' },
            { type: 'minlength', message: 'La nota no puede tener menos de 5 caracteres' },
            { type: 'maxlength', message: 'La nota no puede tener más de 250 caracteres' }
        ],
        'userid': [
            { type: 'required', message: 'User id es requerido' }
        ],
    }
}